module.exports = __webpack_public_path__ + "static/media/revert.04048796.svg";